import { ApolloError } from "@apollo/client";
import React from "react";
import { SortingRule } from "react-table";

import { Alert } from "../../../components";
import { PageOptions } from "../../../types";
import { PositionPageListItemFragment } from "../../graphql";
import PositionList from "./PositionList";

interface MyPositionsProps {
  positions: Array<PositionPageListItemFragment>;
  pageOptions: PageOptions;
  loading?: boolean;
  sortBy: SortingRule<string>;
  error?: ApolloError;
}

const MyPositions: React.FC<MyPositionsProps> = ({
  positions,
  pageOptions,
  loading,
  sortBy,
  error,
}) => {
  // TODO: better error handling
  if (error)
    return (
      <Alert
        status="error"
        title="Error loading positions"
        description={error.message}
      />
    );

  return (
    <PositionList
      positions={positions}
      pageOptions={pageOptions}
      emptyState="Positions you've made calls for will appear here."
      sortBy={sortBy}
      loading={loading}
    />
  );
};

export default MyPositions;
